import React, { PureComponent, createRef, Fragment } from "react";
import "./SocialButtons.scss";
import Classnames from "classnames";
import { ReactComponent as LinkIcon } from "./link.svg";
import { ReactComponent as FbIcon } from "./facebook.svg";
import { ReactComponent as TwitterIcon } from "./twitter.svg";
import { LINK, FB, TWITTER } from "../../constants";
import { timeout } from "d3-timer";
import { checkIfIOSDevice } from "../../utils";

interface Props {
  link: string;
}

interface State {
  linkCopied: boolean;
}

interface Socials {
  social: string;
  link: URL;
  handler: any;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const openWindow = (url: URL, name: string = "_blank") =>
  window.open(url.href, name);

class SocialButtons extends PureComponent<Props, State> {
  private textArea: React.RefObject<HTMLInputElement>;
  constructor(props: Props) {
    super(props);
    this.state = { linkCopied: false };
    this.textArea = createRef();
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  socials: Socials[] = [
    {
      social: LINK,
      link: new URL("https://developer.mozilla.org/en-US/docs/Web/API/URL/URL"),
      handler: (e: any, current: Socials) => this.copyToClipboard(e),
      icon: LinkIcon,
    },
    {
      social: FB,
      link: new URL(
        "https://www.facebook.com/sharer/sharer.php?u=" + this.props.link
      ),
      handler: (e: any, current: Socials) => {
        console.log(current.link.href);
        openWindow(current.link);
      },
      icon: FbIcon,
    },
    {
      social: TWITTER,
      link: new URL(
        "https://twitter.com/intent/tweet?text=" +
          encodeURI(
            "Check out @TrevorProject's National Survey Results. See them here:"
          ) +
          "&url=" +
          this.props.link
      ),
      handler: (e: any, current: Socials) => openWindow(current.link),
      icon: TwitterIcon,
    },
  ];

  // ref: https://stackoverflow.com/a/42844911
  copyToClipboard(e: any) {
    const isIOSDevice = checkIfIOSDevice();
    if (this.textArea.current) {
      if (isIOSDevice) {
        this.textArea.current.setSelectionRange(
          0,
          this.textArea.current.value.length
        );
      } else {
        this.textArea.current.select();
      }
      document.execCommand("copy");
    }
  }

  render() {
    const { link } = this.props;
    const { linkCopied } = this.state;
    return (
      <div className={Classnames("SocialButtons", { linkCopied })}>
        {this.socials.map((d: any, i: number) => (
          <Fragment key={"social-button-" + i}>
            {i === 0 ? (
              <span key={i} className={Classnames("copy-text", { linkCopied })}>
                link copied
              </span>
            ) : null}
            <d.icon
              key={d.social}
              className={Classnames("social-button", d.social)}
              onClick={(e: any) => d.handler(e, d)}
            />
          </Fragment>
        ))}
        <input
          readOnly
          contentEditable
          tabIndex={-1}
          ref={this.textArea}
          value={link}
          onCopy={() => {
            this.setState({ linkCopied: true });
            timeout(() => this.setState({ linkCopied: false }), 3000);
          }}
        />
      </div>
    );
  }
}

export default SocialButtons;
